export const portfolioCategories = [
  {
    label: "Limited template",
    value: "/",
  },
  {
    label: "Customers",
    value: "/customers",
  },
  {
    label: "Designs",
    value: "/designs",
  },
  {
    label: "Team member",
    value: "/team",
  },
];



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/PortfolioModal/constants.js